// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const MobileWalletAmount = () => {
//     const navigate = useNavigate();
//     return (
//         <div className="p-6 bg-white min-h-screen font-sans border">
//             <h2 className="text-lg font-semibold mb-4 text-left">Wallet</h2>

//             {/* Wallet Balance */}
//             <div className="bg-gray-100 p-4 rounded-lg flex items-center justify-between border border-gray-200">
//                 <div className="flex flex-col items-center mx-auto">
//                     <p className="text-sm text-gray-500 text-center">Total Wallet Balance</p>
//                     <p className="text-3xl font-semibold text-green-600 text-center">₹0</p>
//                 </div>
//                 <button
//                     onClick={() => navigate('/wallet-history')}
//                     className="text-sm text-gray-500"
//                 >
//                     Wallet Transaction History
//                 </button>
//             </div>

//             {/* Top Up Wallet */}
//             <div className="mt-6">
//                 <h3 className="text-lg font-semibold text-left">Top Up Wallet</h3>

//                 {/* Input for Custom Top-Up Amount */}
//                 <input
//                     type="text"
//                     placeholder="₹1000"
//                     className="w-full mt-2 p-3 border border-gray-300 rounded-md text-green-600 focus:outline-none focus:border-gray-400"
//                 />

//                 {/* Amount Options */}
//                 <div className="flex gap-2 mt-4">
//                     <button className="py-2 px-4 border rounded-md text-[#FF9630] border-[#FF9630] bg-white">₹500</button>
//                     <button className="py-2 px-4 border rounded-md text-gray-700 border-gray-300 bg-white">₹1000</button>
//                     <button className="py-2 px-4 border rounded-md text-gray-700 border-gray-300 bg-white">₹2000</button>
//                 </div>

//                 {/* Top-Up Button */}
//                 <button className="w-full mt-4 py-3 bg-[#FF9630] text-white font-semibold rounded-md hover:bg-[#FF9630]">
//                     PROCEED TO TOP-UP
//                 </button>
//             </div>

//             {/* Rewards and Refund Section */}
//             <div className="mt-6 space-y-2">
//                 <div className="flex justify-between items-center border border-gray-200 p-4 rounded-md bg-white shadow-sm">
//                     <div>
//                         <p className="font-semibold">Move On Wheels Rewards</p>
//                         <p className="text-sm text-gray-500">25% Utilization On Cart Value</p>
//                     </div>
//                     <p className="font-semibold">₹500</p>
//                 </div>

//                 <div className="flex justify-between items-center border border-gray-200 p-4 rounded-md bg-white shadow-sm">
//                     <div>
//                         <p className="font-semibold">Refund</p>
//                         <p className="text-sm text-gray-500">100% Utilization</p>
//                     </div>
//                     <p className="font-semibold">₹0</p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MobileWalletAmount;


import React, { useState } from 'react';
import MobileWalletHistory from './MobileWalletHistory';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileWalletAmount = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(0);
    };
    return (
        <>
            <div className="w-full bg-[#FF9630] text-white py-4 px-4 flex items-center">
                <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
                    <FaArrowLeft className="text-lg" />
                </button>
                <h1 className="text-xl font-semibold">Wallet</h1>
            </div>
            <div className="p-6 bg-white min-h-screen font-sans border">

                <div className="bg-gray-100 p-4 rounded-lg flex items-center justify-between border border-gray-200">
                    <div className="flex flex-col items-center mx-auto">
                        <p className="text-sm text-gray-500 text-center">Total Wallet Balance</p>
                        <p className="text-3xl font-semibold text-green-600 text-center">₹0</p>
                    </div>

                </div>

                {/* Top Up Wallet */}
                <div className="mt-6">
                    <h3 className="text-lg font-semibold text-left">Top Up Wallet</h3>

                    {/* Input for Custom Top-Up Amount */}
                    <input
                        type="text"
                        placeholder="₹1000"
                        className="w-full mt-2 p-3 border border-gray-300 rounded-md text-green-600 focus:outline-none focus:border-gray-400"
                    />

                    {/* Amount Options */}
                    <div className="flex gap-2 mt-4">
                        <button className="py-2 px-4 border rounded-md text-[#FF9630] border-[#FF9630] bg-white">₹500</button>
                        <button className="py-2 px-4 border rounded-md text-gray-700 border-gray-300 bg-white">₹1000</button>
                        <button className="py-2 px-4 border rounded-md text-gray-700 border-gray-300 bg-white">₹2000</button>
                    </div>

                    {/* Top-Up Button */}
                    <button onClick={() => setIsModalOpen(true)} className=" w-full mt-4 py-3 bg-[#FF9630] text-white font-semibold rounded-md hover:bg-[#FF9630]">
                        Wallet Transaction History
                    </button>
                </div>

                {/* Rewards and Refund Section */}
                <div className="mt-6 space-y-2">
                    <div className="flex justify-between items-center border border-gray-200 p-4 rounded-md bg-white shadow-sm">
                        <div>
                            <p className="font-semibold">Move On Wheels Rewards</p>
                            <p className="text-sm text-gray-500">25% Utilization On Cart Value</p>
                        </div>
                        <p className="font-semibold">₹500</p>
                    </div>

                    <div className="flex justify-between items-center border border-gray-200 p-4 rounded-md bg-white shadow-sm">
                        <div>
                            <p className="font-semibold">Refund</p>
                            <p className="text-sm text-gray-500">100% Utilization</p>
                        </div>
                        <p className="font-semibold">₹0</p>
                    </div>
                </div>
               
                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center h-screen z-50">
                        <div className="w-full max-w-md bg-white h-screen rounded-lg">
                            <div className="">
                                <MobileWalletHistory />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default MobileWalletAmount;
